import React from 'react';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { closeDataModal } from 'handimap-react-lib/store/actions/modalActions';
import { useResponsive } from 'handimap-react-lib/hooks/useResponsive';
import { FontAwesomeSvgIcon } from 'handimap-react-lib/components/FontAwesomeSvgIcon';

export const DataModal = () => {
  /**
   * Accessibility infos: https://www.w3.org/WAI/ARIA/apg/patterns/dialogmodal/
   *                      https://www.accede-web.com/notices/interface-riche/fenetres-modales/
   */
  const { openData } = useSelector(state => state.modalZone); 
  const dispatch = useDispatch();
  const { isMobile } = useResponsive();
  const {t} = useTranslation();

  const handleCloseModal = () => {
    dispatch(closeDataModal());
  };
  const style = {
    container: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      borderRadius: '1em',
      boxShadow: 24,
      paddingX: 4,
      paddingBottom: 4,
      outline: 'none',
      maxHeight:'80%',
      minWidth: isMobile ? '80%' : 600, 
      overflow: 'auto'
    },
    contentContainer: {
      display: 'flex', 
      width: '100%',
      top: 0,
      justifyContent: 'flex-end',
      backgroundColor: 'inherit',
      position: 'sticky', 
      zIndex: 100
    },
    closeIcon: {
      backgroundColor: 'white', 
      marginTop:'0.5em',
      color: 'primary.main'
    },
    content: {
      display: 'flex', 
      maxHeigth:'80%'
    }
  };

  return (
    <Modal
      open={openData}
      onClose={() => handleCloseModal()}
      aria-labelledby="modal-zone-title"
      aria-describedby="modal-zone-description"
      role="dialog" 
      aria-modal="true"
    >
      <Box sx={style.container}>
        <Box sx={style.contentContainer}>
          <IconButton 
            aria-label={t('modal-data.close-modal')} 
            variant='text' 
            sx={style.closeIcon} 
            onClick={() => handleCloseModal()}
          >
            <FontAwesomeSvgIcon icon={faTimes} />
          </IconButton>
        </Box>
        <Stack sx={style.content} direction='column' spacing={2}>
          <Box sx={{alignSelf: 'center'}}>
            <Typography id="modal-zone-title" variant="h4" component="h1">
              {t('modal-data.title')}
            </Typography>
          </Box>
          <Typography id="modal-zone-description" sx={{whiteSpace: 'pre-line'}}>
            {t('modal-data.intro')}
          </Typography>
        </Stack>
      </Box>
    </Modal>
  );
};